import { CheckBox, StyledText } from '@clickcease/cc-client-components-lib'

import {
  IdsSelectionRow,
  IdsTitleRow,
} from '../../../../../common/StandardCheckboxModal/StandardCheckboxModal.styled'
import { GenericPlatformEntity } from '../../../../../../models'
import React from 'react'

interface AdAccountPixelsProps {
  adAccountName: string
  pixelsToShow: GenericPlatformEntity[]
  selectedAccounts: number[]
  handleSelect: (a: number) => void
  isReadOnly?: boolean
  isAllSelected?: boolean
}

export const AdAccountPixels = ({
  isReadOnly,
  pixelsToShow,
  selectedAccounts,
  handleSelect,
  isAllSelected,
  adAccountName,
}: AdAccountPixelsProps) => {
  return (
    <>
      <IdsTitleRow key={'row' + adAccountName}>
        <StyledText variant={'baseBold'}>{adAccountName}</StyledText>
      </IdsTitleRow>
      {pixelsToShow.map((account, num) => (
        <IdsSelectionRow key={account.id} noBorder={pixelsToShow.length === num + 1}>
          <CheckBox
            isChecked={isAllSelected || selectedAccounts.includes(account.id)}
            onChange={() => handleSelect(account.id)}
            disabled={isReadOnly}
          />
          <StyledText variant={'baseLight'}>{account.name}</StyledText>
          <StyledText variant={'baseLight'}>
            {account.adAccountId ||
              account.adAccountID ||
              account.campaignId ||
              account.managerId ||
              ''}
          </StyledText>
        </IdsSelectionRow>
      ))}
    </>
  )
}
